import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const postDocumentCategory = (
    token: string,
    backend: string,
    Name: string,
) => {
    return fetch(
        `${getApiUrl(backend)}create_document_category`,
        {
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                Name,

            })
        }
    );
};

export default postDocumentCategory;
